import PBService from "@irati/utils/services"
import client, {QueryOptions} from "@irati/utils/services/apollo"
import {QueryRewardsReportingUrlArgs} from "@irati/types/ops"

import rewardsReportingUrl, {rewardsReportingUrlKey} from "./queries/rewardsReportingUrl"

class RewardsReportService extends PBService {
  getRewardsReportUrl = (variables: QueryRewardsReportingUrlArgs, options: QueryOptions = {}) => {
    return client.query({...options, query: rewardsReportingUrl, variables}).then(({data}) => {
      return data[rewardsReportingUrlKey]
    })
  }
}

const rewardsReportService = new RewardsReportService({errorHandlers: []})

export default rewardsReportService
